import actionCreatorFactory from 'typescript-fsa';

import { IFetchELearningProgressParam } from 'src/scenario/ELearningScenarioFactory';

const actionCreator = actionCreatorFactory();

/** アンケートページ初期化 */
export const initQuestionnaire = actionCreator<IFetchELearningProgressParam>(
	'INIT_QUESTIONNAIRE'
);

/** アンケート一覧 */
export interface IQuestionnaireBlock {
	blockID: string;
	blockNo?: string;
	blockName: string;
	questionnaires: IQuestionnaire[];
}

/** アンケート情報 */
export interface IQuestionnaire {
	questionnaireID: string;
	questionnaireType?: string;
	questionnaireNo: string;
	questionnaireText: string;
	selectedReply?: number;
	options?: IOption[] | null;
	mustFlg?: number;
}

/** アンケート形式 */
export enum QuestionnaireType {
	SELECT = '1', // プルダウンリスト
	RADIO_BUTTON = '2', // ラジオボタン
	CHECK_BOX = '3', // チェックボックス
	TEXT_AREA = '4', // テキストエリア
}

/** 選択肢 */
export interface IOption {
	replyOrder?: number;
	replyText: string;
	selected?: boolean;
}

/** eラーニングアンケート情報設定アクションクリエータ */
export const setQuestionnaireParams = actionCreator<{
	blocks: IQuestionnaireBlock[];
	displayTmpSaveBtn: boolean;
	enqueteName: string;
	mustAnswerFlg: number;
	startTime: string;
	renewalDate: string;
	periodJudgment: number;
	scoreItemsRegisterFlag: string;
	respondentCategoryFlg: string;
}>('SET_QUESTIONNAIRE_PARAMS');

/** eラーニングアンケート表形式時選択肢設定アクションクリエータ */
export const setQuestionnaireGridOptions = actionCreator<{
	options: IOption[];
}>('SET_QUESTIONNAIRE_GRID_OPTIONS');

/** eラーニングアンケート情報初期化アクションクリエータ */
export const clearQuestionnaireParams = actionCreator<{}>(
	'CLEAR_QUESTIONNAIRE_PARAMS'
);



// WEBPACK FOOTER //
// ./src/actions/questionnaire.ts